const homeRouter = () => {
    return [
        {
            path: 'home-v',
            name: 'home-v',
            component: () => import(/* webpackChunkName: "home" */'../../modules/home/index.vue')
        }
    ];
};
export default homeRouter;
